import React from 'react'
import {Mutation} from 'react-apollo'

import AddGoodReviewLayout from './layout'
import addGoodReviewGql from './add-good-review.graphql'

const AddGoodReviewWithMutation = (props) => {
  return <Mutation mutation={addGoodReviewGql}>
    {(addGoodReview, {data, error}) => <AddGoodReviewLayout
      {...props}
      addGoodReview={addGoodReview}
      done={data && data.addGoodReview && !data.addGoodReview.error}
      error={error || (data && data.addGoodReview && data.addGoodReview.error)}
    />}
  </Mutation>
}

export default AddGoodReviewWithMutation


